










































/*
    * Method for pupulate text input control - STARTS
    1. groups     - Set of field names, these fields 'll be displayed as a group.
*/
import Vue from 'vue';
import Vuex from 'vuex';
import * as _ from 'lodash';
import { Component, Prop } from "vue-property-decorator";
import FormComponents from "./../../Form.vue";

/*
    * Component's properties and events
*/
@Component({
    components: {
        FormComponents
    }    
})

export default class PivotComponent extends Vue {
    /*
        * Component's props
    */
    @Prop() readonly groups!: string;

    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    data() {
         // @ts-ignore
        return this.$store.state[this.$options.parent.fileName];
    }

    /*
        * Expand or collapse form group set
    */
    _fgExpandOrCollapse(settings) {
        if (settings.collapse)
            settings.collapse = false;
        else
            settings.collapse = true;
    }    
}
